import { render, staticRenderFns } from "./全站搜索.vue?vue&type=template&id=5a6f9836&scoped=true"
import script from "./全站搜索.vue?vue&type=script&lang=js"
export * from "./全站搜索.vue?vue&type=script&lang=js"
import style0 from "./全站搜索.vue?vue&type=style&index=0&id=5a6f9836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6f9836",
  null
  
)

export default component.exports